module.exports = {"Enterprise4":{"daobanList":[{"title":"1:是否为法律、行政法规和国务院决定规定备案事项必须报经批准的？","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"《公司登记（备案）申请书》","state":"必要"},{"name":"法律、行政法规和国务院决定规定备案事项必须报经批准的，提交有关的批准文件或者许可证件复印件","state":"非必要"},{"name":"备案事项证明文件","state":"必要"}]},{"name":"否","xuanzhong":0,"cailiaoList":[{"name":"《公司登记（备案）申请书》","state":"必要"},{"name":"备案事项证明文件","state":"必要"}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sde-4.json
// module id = 1251
// module chunks = 0